import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { productsearchProduct } from "../../services/Apis";
import {
  setsearchinput,
  setorderSelectedproducts,
  setinitial_page,
} from "../../slices/globalslice";
import {
  setupdateddata,
  setorderamount,
  setordersearchselectproduct,
  setorderselectedvendorproducts,
} from "../../slices/orderslice";
import useFormvalidation from "../../hooks/validations/useFormvalidation";
import { TextInput, SearchComponent } from "../../Components/Common/FormInputs";
import { Row, Col, Container, Button } from "reactstrap";
import TableContainer from "../../Components/Common/DataTables/TableContainer";
import ErrorBoundary from "../../Components/Common/ErrorBoundary";
import Order from "../../actions/Order";
import Vendorlistproducts from "./Vendorlistproducts";
import useOrder from "../../hooks/useOrder";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
const Addproducts = ({ countryid, areaid, type, productid, countryData }) => {
  const currentCountry = useMemo(() => {
    return countryData?.find(c => c.country_id === countryid) || {};
  }, [countryid, countryData]);


  const countryCurrency = currentCountry?.currency || "";
  const dispatch = useDispatch();
  const { slug } = useParams()
  const { selectedsearchProduct } = Order();
  const { ProvideRefund } = useOrder();
  const location = useLocation();
  const isWebfeedAdd = location.pathname.includes("webfeed/add");

  const orderSelectedproducts = useSelector((state) => state.globalslice.orderSelectedproducts);
  const searchinput = useSelector((state) => state.globalslice.searchinput);
  const ordershippingcharges = useSelector((state) => state.orderslice.ordershippingcharges);
  const orderbalanceamount = useSelector((state) => state.orderslice.orderbalanceamount);
  const creditedamount = useSelector((state) => state.orderslice.creditedamount);
  const orderdiscountcharges = useSelector((state) => state.orderslice.orderdiscountcharges);
  const orderdonationfee = useSelector((state) => state.orderslice.orderdonationfee);
  const processing_fee = useSelector((state) => state.orderslice.processing_fee);
  // const chargesfee = useSelector((state) => state.orderslice.chargesfee);
  const orderAddress = useSelector((state) => state.orderslice.orderAddress);
  const ordersearchselectproduct = useSelector((state) => state.orderslice.ordersearchselectproduct);
  const orderselectedvendorproducts = useSelector((state) => state.orderslice.orderselectedvendorproducts);
  const [quantities, setQuantities] = useState({});
  const [alertShown, setAlertShown] = useState(false);
  const [searchdata, setsearchdata] = useState([]);
  const [selected_value, setselected_value] = useState("");
  const [shippingCharge, setShippingCharge] = useState(slug ? 0 : Number(ordershippingcharges) || 0);
  const [balance_amount, setbalance_amount] = useState(Number(orderbalanceamount) || 0);
  const [discount, setDiscount] = useState(Number(orderdiscountcharges) || 0);
  const [donation, setDonation] = useState(Number(orderdonationfee) || 0);
  const [processingfee, setprocessingfee] = useState(Number(processing_fee) || 0);
  // const [Charges, setCharges] = useState(Number(chargesfee) || 0);
  const { values, setValues } = useFormvalidation({ searchid: "" });

  const [selectedCheckBox, setSelectedCheckBox] = useState([]);

  // Update shipping and discount from Redux when they change
  useEffect(() => {
    setShippingCharge(Number(ordershippingcharges));
    setDiscount(Number(orderdiscountcharges));
    setbalance_amount(Number(orderbalanceamount));
    setDonation(Number(orderdonationfee));
    setprocessingfee(Number(processing_fee));
    // setCharges(Number(chargesfee));
  }, [ordershippingcharges, orderdiscountcharges, processing_fee, orderbalanceamount, orderdonationfee]);

  useEffect(() => {
    dispatch(setinitial_page(1))
  }, [])

  useEffect(() => {
    dispatch(setorderSelectedproducts([]));
  }, [slug])

  useEffect(() => {
    if (countryid && !slug) {

      dispatch(setorderSelectedproducts([]));
      dispatch(setordersearchselectproduct([]));
      dispatch(setorderselectedvendorproducts([]));
      dispatch(setupdateddata([]));
      setQuantities({});
      setSelectedCheckBox([]);
      setAlertShown(false);
    }
  }, [countryid]);

  // Fetch product when selected_value changes
  useEffect(() => {
    if (selected_value !== "") {
      selectedsearchProduct(values.searchid, countryid, areaid);
      setselected_value("")
      setValues({ ...values, searchid: "" });
    }
  }, [selected_value]);

  useEffect(() => {
    if (orderSelectedproducts && orderSelectedproducts?.length > 0) {
      const updatedProducts = orderSelectedproducts.map(p => ({
        ...p,
        rstatus: p.status === "delete" ? 0 : 1,
      }));
      dispatch(setupdateddata(updatedProducts));
    }
  }, [orderSelectedproducts, dispatch]);


  useEffect(() => {
    const newQuantities = { ...quantities };
    let updatedProducts = orderSelectedproducts?.map((p) => {
      if (!(p.productid in newQuantities)) {
        newQuantities[p.productid] = (type == 'return' ? (p.quantity - p.return_quantity) : p.quantity ?? 1);
      }
      return p;
    });

    updatedProducts = updatedProducts?.map(p => {
      if (p.status !== "delete") {
        return { ...p, rstatus: 1 };
      }
      return p;
    });
    setQuantities(newQuantities);
    dispatch(setupdateddata(updatedProducts));
  }, [orderSelectedproducts]);

  // Update Redux updated data whenever quantities change
  useEffect(() => {
    const updatedProducts = orderSelectedproducts?.map((p) => ({
      ...p,
      quantity: quantities[p.productid] ?? 1,
    }));
    dispatch(setupdateddata(updatedProducts));
  }, [quantities]);


  // Search product handler
  const handleProductChange = async (value) => {
    if (value !== "") {
      const response = await productsearchProduct(value);
      setsearchdata(response);
    }
  };
  const SearchDropdownData = [
    { label: "None", value: 0 },
    ...(searchdata?.data?.map((item) => ({
      label: `${item.title} (${item.sku})`,
      value: item.productid,
    })) || []),
  ];
  //     useEffect(() => {
  //   if (!countryid) return; // still runs every render, just exits early

  //   dispatch(setorderSelectedproducts([]));
  //   dispatch(setupdateddata([]));
  //   setQuantities({});
  //   setSelectedCheckBox([]);
  //    setAlertShown(false); 
  // }, [countryid]);
  // Set selected product in Redux when dropdown changes
  useEffect(() => {
    if (selected_value !== "") {
      const selectedProduct = searchdata?.data?.find(
        (item) => item.productid === selected_value
      );
      dispatch(setordersearchselectproduct(selectedProduct));
    }
  }, [selected_value]);

  const handleAddVendorProduct = (selectedVendor) => {
    if (!ordersearchselectproduct || !selectedVendor) return;

    const exists = orderSelectedproducts?.some(
      (p) => p.productid === ordersearchselectproduct.productid
    );

    if (exists) {
      if (!alertShown) {
        toast.error("This product is already added.");
        setAlertShown(true);
      }
      return;
    }
    const mergedProduct = {
      ...ordersearchselectproduct,
      ...selectedVendor,
      quantity: 1,
      status: "new",
      orderdetail_id: 0,
      rstatus: 1,
      product_sku: ordersearchselectproduct.sku,
    };
    const updatedList = [...orderSelectedproducts, mergedProduct];
    dispatch(setorderSelectedproducts(updatedList));
    dispatch(setupdateddata(updatedList));
    setValues({ ...values, searchid: "" });
    setselected_value("");
    dispatch(setordersearchselectproduct(null));
    setAlertShown(false); // reset alert flag after successful addition
  };
  const handleRemoveProduct = (productid) => {
    const updatedProducts = orderSelectedproducts
      .map((p) => {
        if (p.productid === productid) {
          if (p.status === "new") {
            return null; // remove newly added product
          }
          return { ...p, status: "delete", rstatus: 0 }; // mark existing as deleted immutably
        }
        return p;
      })
      .filter(Boolean);

    dispatch(setorderSelectedproducts(updatedProducts));
    dispatch(setupdateddata(updatedProducts));

    setQuantities((prev) => {
      const newQty = { ...prev };
      delete newQty[productid];
      return newQty;
    });
  };
  const columns = useMemo(() => [
    {
      header: "Products",
      accessorKey: "title",
      cell: ({ row }) => (
        <div>
          {row.original.title}
          {row.original.product_sku ? ` - (${row.original.product_sku})` : ""}
        </div>
      ),

    },
    {
      header: "Vendor",
      enableSorting: false,
      accessorKey: "business_name",
      cell: ({ row }) => row.original.business_name,
    },
    {
      header: "Stock",
      enableSorting: false,
      accessorKey: "inventory",
      cell: ({ row }) =>
        row.original.inventory === 0 ? (
          <span className="badge bg-danger-subtle text-danger text-uppercase">Out Of Stock</span>
        ) : (
          row.original.inventory
        ),
    },
    // {
    //   header: "Qty",
    //   accessorKey: "quantity",
    //   cell: ({ row }) => (
    //     <input
    //       type="number"
    //       min="1"
    //       max={type == 'return' ? row.original.quantity - row.original.return_quantity : row.original.inventory}
    //       value={quantities[row.original.productid] ?? 1}
    //       onChange={(e) => handleQtyChange(row.original.productid, e.target.value)}
    //       style={{ width: "60px" }}
    //     />
    //   ),
    // },
    {
      header: "Qty",
      enableSorting: false,
      accessorKey: "quantity",
      cell: ({ row }) => {
        const productid = row.original.productid;
        const currentQty = quantities[productid] !== undefined ? quantities[productid] : "";

        const handleBlur = () => {
          const value = Number(quantities[productid]);
          if (isNaN(value) || value < 1) {
            setQuantities((prev) => ({ ...prev, [productid]: 1 }));
          }
        };

        return (
          <TextInput
            type="number"
            min="1"
            value={currentQty}
            onChange={(e) => handleQtyChange(productid, row?.original?.quantity, row?.original?.return_quantity, e.target.value)}
            onBlur={handleBlur}
            style={{ width: "70px", padding: "4px" }}
          />
        );
      },
    },


    {
      header: "Price",
      enableSorting: false,
      accessorKey: "selling_price",
    },
    {
      header: "",
      accessorKey: "orderdetail_id",
      enableSorting: false,
      cell: ({ row }) => (
        <>
          {
            type == 'return' ?
              <input
                type="checkbox"
                className="orderCheckBox form-check-input"
                disabled={type == 'return' && (row.original.quantity - row.original.return_quantity == 0) && true}
                value={row.original.orderdetail_id}
                defaultChecked={selectedCheckBox.map(p => p.orderdetail_id).includes(row.original.orderdetail_id)}
                onChange={(e) => {
                  const value = row.original.orderdetail_id;
                  if (e.target.checked) {
                    setSelectedCheckBox((prev) => [...prev,
                    {
                      orderdetail_id: row.original.orderdetail_id,
                      productid: row.original.productid,
                      return_quantity: 0
                    }
                    ]);
                  } else {
                    setSelectedCheckBox((prev) => prev.filter(({ orderdetail_id }) => orderdetail_id !== value));
                  }
                }}
              />
              :
              <button
                type="button"
                className="btn p-1 btn-soft-danger"
                onClick={() => handleRemoveProduct(row.original.productid)}
              >
                <i className="ri-delete-bin-2-line"></i>
              </button>
          }
        </>
      ),
    },
  ], [quantities]);


  const visibleProducts = orderSelectedproducts?.filter((p) => p.status !== "delete");

  const subtotalwithvat = visibleProducts?.reduce((acc, item) => {
    const qty = quantities[item.productid] ?? 1;
    return acc + item.selling_price * qty;
  }, 0);



  const totalBeforeDiscount = subtotalwithvat + Number(shippingCharge) + Number(processingfee) + Number(balance_amount);
  const vatAmount = +((totalBeforeDiscount * currentCountry?.vat/100).toFixed(2));
  const subtotal = subtotalwithvat - vatAmount;
  const total = +(totalBeforeDiscount + Number(donation) + - Number(discount) - creditedamount).toFixed(2);

  useEffect(() => {
    dispatch(
      setorderamount({
        subtotal,
        vatAmount,
        total,
        processing_fee: Number(processingfee),
        balance_amount: Number(balance_amount),
        shippingCharge: Number(shippingCharge),
        discount: Number(discount),
        donation_fee: Number(donation)
      })
    );
  }, [subtotal, vatAmount, total, shippingCharge, processingfee, balance_amount, discount, donation]);

  const handleReturn = (type) => {
    const payload = {
      "orderid": productid,
      "return_type": type,
      "_comment": "where return_type is refund or replacement",
      "product_details": selectedCheckBox.map((item) => {
        return {
          ...item,
          return_quantity: quantities[item?.productid]
        }
      })
    }
    ProvideRefund.mutate(payload)
  }


  // const handleQtyChange = (productid, value) => {
  //   const num = Number(value);
  //   if (!isNaN(num) && num >= 1) {
  //     setQuantities((prev) => ({ ...prev, [productid]: num }));
  //   }
  // };
  // const handleQtyChange = (productid,quantity,return_quantity, value) => {
  //   // Allow clearing input temporarily for typing
  //   if (value === "") {
  //     setQuantities((prev) => ({ ...prev, [productid]: "" }));
  //     return;
  //   }

  //   const num = Number(value);
  //   if (!isNaN(num) && num >= 1) {
  //     setQuantities((prev) => ({ ...prev, [productid]: num }));
  //   }
  // };

  const handleQtyChange = (productid, quantity, return_quantity, value) => {
    const updated_quantity = quantity - return_quantity;
    // Allow clearing input temporarily for typing
    if (value === "") {
      setQuantities((prev) => ({ ...prev, [productid]: "" }));
      return;
    }

    const num = Number(value);

    if (!isNaN(num) && num >= 1) {
      // ✅ Restrict user from entering more than available quantity
      if (num > updated_quantity && type == 'return') {
        setQuantities((prev) => ({ ...prev, [productid]: updated_quantity }));
      } else {
        setQuantities((prev) => ({ ...prev, [productid]: num }));
      }
    }
  };





  return (
    <ErrorBoundary>
      <div className="table-responsive">
        <TableContainer
          perPageNotRequired
          columns={columns}
          data={visibleProducts}
          customPageSize={100}
          disableSearch
          disableNavigation
        />

        {
          type == 'return' &&
          <div className="d-flex justify-content-end mt-3">
            <Button color="primary" outline className="btn-sm me-2" disabled={selectedCheckBox?.length <= 0 && true} onClick={() => handleReturn('refund')}>
              Refund
            </Button>
            <Button color="primary" outline className="btn-sm me-2" disabled={selectedCheckBox?.length <= 0 && true} onClick={() => handleReturn('replacement')}>
              Replacement
            </Button>
          </div>

        }


        <Container fluid className="mt-4">
          <Row>
            <Col lg={4}>
              <SearchComponent
                placeholder="Search by Sku or Product Title"
                name="searchid"
                setValues={setValues}
                values={values}
                value={values?.searchid}
                onSearch={handleProductChange}
                setselected_value={setselected_value}
                options_data={SearchDropdownData}
              />
            </Col>
          </Row>

          {ordersearchselectproduct && (
            <Row className="mt-3">
              <Col lg={12}>
                {orderselectedvendorproducts?.filter(
                  (v) => v.productid === ordersearchselectproduct.productid
                ).length > 1 ? (
                  <>
                    <strong>{ordersearchselectproduct.title}</strong>
                    <Vendorlistproducts
                      listdata={orderselectedvendorproducts.filter(
                        (v) => v.productid === ordersearchselectproduct.productid
                      )}
                      onAdd={handleAddVendorProduct}
                    />
                  </>
                ) : (
                  handleAddVendorProduct(
                    orderselectedvendorproducts.find(
                      (v) => v.productid === ordersearchselectproduct.productid
                    )
                  )
                )}
              </Col>
            </Row>
          )}

          <Row className="mt-4">
            <Col lg={6}></Col>
            <Col lg={6}>
              <table className="table table-sm table-borderless mb-0">
                <tbody>
                  <tr>
                    <td>Sub Total :</td>
                    <td className="text-end">{countryCurrency}{" "}{subtotal?.toFixed(2)}</td>
                  </tr>
                  {
                    !isWebfeedAdd &&
                    <>
                      <tr>
                        <td>Shipping Charges :</td>
                        <td className="text-end d-flex justify-content-end order_custom_input">
                          <span className="me-2">{countryCurrency}</span>
                          <TextInput
                            allowOnlyNumbers
                            allowDecimals
                            input_type={1}
                            name="shippingCharge"
                            value={shippingCharge}
                            onChange={(e) => setShippingCharge(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Processing fee :</td>
                        <td className="text-end d-flex justify-content-end order_custom_input">
                          <span className="me-2">{countryCurrency}</span>
                          <TextInput
                            allowOnlyNumbers
                            allowDecimals
                            input_type={1}
                            name="processingfee"
                            value={processingfee}
                            onChange={(e) => setprocessingfee(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Balance Amount :</td>
                        <td className="text-end d-flex justify-content-end order_custom_input">
                          <span className="me-2">{countryCurrency}</span>
                          <TextInput
                            allowOnlyNumbers
                            allowDecimals
                            input_type={1}
                            name="balance_amount"
                            value={balance_amount}
                            onChange={(e) => setbalance_amount(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Discount :</td>
                        <td className="text-end d-flex justify-content-end order_custom_input">
                          <span className="me-2">{countryCurrency}</span>
                          <TextInput
                            allowOnlyNumbers
                            allowDecimals
                            input_type={1}
                            name="discount"
                            value={discount}
                            onChange={(e) => setDiscount(e.target.value)}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Donation fee :</td>
                        <td className="text-end d-flex justify-content-end order_custom_input">
                          <span className="me-2">{countryCurrency}</span>
                          <TextInput
                            allowOnlyNumbers
                            input_type={1}
                            name="donation"
                            value={donation}
                            onChange={(e) => setDonation(e.target.value)}
                          />
                        </td>
                      </tr>
                    </>
                  }

                  {/* <tr>
                    <td>Charges :</td>
                    <td className="text-end order_custom_input">
                      <TextInput
                        input_type={1}
                        name="Charges"
                        value={Charges}
                        onChange={(e) => setCharges(e.target.value)}
                      />
                    </td>
                  </tr> */}
                  <tr>
                    <td>{`${currentCountry?.vat}%`} VAT :</td>
                    <td className="text-end">{countryCurrency}{" "}{vatAmount?.toFixed(2)}</td>
                  </tr>
                  {
                    creditedamount != null && creditedamount != 0 &&
                    <tr>
                      <td>Credit Amount:</td>
                      <td className="text-end">{countryCurrency}{" "}{creditedamount}</td>
                    </tr>
                  }
                  <tr className="border-top border-top-dashed">
                    <th>Total :</th>
                    <th className="text-end">{countryCurrency}{" "} {total?.toFixed(2)}</th>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </Container>
      </div>
    </ErrorBoundary>
  );
};

export default React.memo(Addproducts);
